import { useMemo, useState } from "react";
import { Play } from "lucide-react";
import { videoEmbed } from "@/lib/media";

/** Click-to-play facade – nothing from YouTube/Vimeo loads until the visitor asks for it. */
export const EventVideo = ({ url, title }) => {
  const v = useMemo(() => videoEmbed(url), [url]);
  const [play, setPlay] = useState(false);
  if (!v) return null;
  return (
    <section className="mt-14 border-t border-border pt-10" data-testid="event-video">
      <p className="t-mono text-muted-foreground">Video</p>
      <div className="relative mt-4 aspect-video overflow-hidden rounded-[16px] bg-ink ring-1 ring-border">
        {play ? (
          <iframe src={v.embed} title={`Video: ${title}`} allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowFullScreen className="absolute inset-0 h-full w-full" data-testid="event-video-iframe" />
        ) : (
          <button type="button" onClick={() => setPlay(true)} className="group absolute inset-0 flex items-center justify-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sol" aria-label="Spel av video" data-testid="event-video-play">
            {v.thumb && <img src={v.thumb} alt="" className="absolute inset-0 h-full w-full object-cover opacity-80 transition-transform duration-700 group-hover:scale-[1.03]" />}
            <span className="absolute inset-0 bg-gradient-to-t from-ink/70 via-ink/10 to-ink/20" aria-hidden="true" />
            <span className="relative flex h-16 w-16 items-center justify-center rounded-full bg-paper text-ink shadow-2xl transition-transform duration-300 group-hover:scale-105 sm:h-20 sm:w-20"><Play className="ml-1 h-6 w-6 fill-current sm:h-7 sm:w-7" /></span>
            <span className="t-mono absolute bottom-4 left-5 text-paper/80">{v.provider === "youtube" ? "YouTube" : "Vimeo"}</span>
          </button>
        )}
      </div>
    </section>
  );
};
